import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchGuardianProfile } from '../../services/guardians';

// Async thunk for fetching guardian profile
export const fetchGuardianProfileThunk = createAsyncThunk(
  'profile/fetchGuardianProfile',
  async (userId, { rejectWithValue }) => {
    try {
      const { data, error } = await fetchGuardianProfile(userId);

      if (error) {
        return rejectWithValue(error);
      }

      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const profileSlice = createSlice({
  name: 'profile',
  initialState: {
    guardianProfile: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearProfile: (state) => {
      state.guardianProfile = null;
      state.error = null;
      state.loading = false;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGuardianProfileThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGuardianProfileThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.guardianProfile = action.payload;
        state.error = null;
      })
      .addCase(fetchGuardianProfileThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { clearProfile, clearError } = profileSlice.actions;

// Selectors
export const selectGuardianProfile = (state) => state.profile.guardianProfile;
export const selectProfileLoading = (state) => state.profile.loading;
export const selectProfileError = (state) => state.profile.error;

export default profileSlice.reducer;
